import React from "react"

export default function Dashboard() {
  return <p>Dashboard</p>
}
